import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertComponent } from 'src/app/alert/alert.component';

@Component({
  selector: 'app-registration-form',
  templateUrl: './registration-form.component.html',
  styleUrls: ['./registration-form.component.scss']
})
export class RegistrationFormComponent {
  name: any;
  email: any;
  mobile: any;
  purpose: any;
  show: any = true;

  constructor(private dialog: MatDialog) { }

  restrictToNumbers(event: any) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '');
  }

  getName(event: any) {
    this.name = event.target.value
  }

  getemail(event: any) {
    this.email = event.target.value
  }

  getmobile(event: any) {
    this.mobile = event.target.value
  }

  getpurpose(event: any) {
    this.purpose = event.target.value
  }

  submit() {
    if (this.email && this.mobile && this.name) {
      if (this.mobile.length == 10) {
        // this.dialog.open(AlertComponent, {
        //   width: 'auto',
        //   height: '50px',
        //   position: { top: '10px', right: '10px' },
        //   data: {
        //     data: "Thank you! Our team will review your request and contact you shortly.",
        //     status: "Success"
        //   }
        // })
        this.show = false;
      }
      else {
        this.dialog.open(AlertComponent, {
          width: 'auto',
          height: '50px',
          position: { top: '10px', right: '10px' },
          data: {
            data: "Please enter valid mobile number ",
            status: "Warning"
          }
        })
      }
    }
    else {
      this.dialog.open(AlertComponent, {
        width: 'auto',
        height: '50px',
        position: { top: '10px', right: '10px' },
        data: {
          data: "Please fill all the important details",
          status: "Warning"
        }
      })
    }


  }
}
